import { helper } from '@ember/component/helper';

import { mapLocationUrl } from 'rise-ui/utils/external-map.js';
import { getProperties } from 'rise-ui/utils/object.js';

export default helper(function linkToMapForLocationHelper([ location = {} ]) {
  const { geometry, id } = getProperties(location, '{geometry,id}');
  return geometry && id ? mapLocationUrl(geometry, id) : '#';
});
